import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPostDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getAdjustList = (projectCode, period, request) => {
  const url = `${API_ROOT}/v1/accounting/adjust/list/${projectCode}/${period}`
  return doPost(url, request)
}

export const getAdjust = (projectCode, period, id) => {
  const url = `${API_ROOT}/v1/accounting/adjust/${projectCode}/${period}?id=${id || ''}`
  return doGet(url)
}

export const saveAdjust = (request) => {
  const url = `${API_ROOT}/v1/accounting/adjust`
  return doPost(url, request)
}

export const getAdjustAttachments = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/adjust/attachments/download/${fileId}`
  return doDownload(url)
}

export const deleteAdjust = (id) => {
  const url = `${API_ROOT}/v1/accounting/adjust/${id}`
  return doDelete(url)
}

export const downloadAdjustListFile = (mainProjectCode, voucherNo, id) => {
  // const API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/${mainProjectCode}/${voucherNo}/${id}/accounting/general-voucher/file`
  return doDownload(url)
}
